import { ReactElement, ReactNode } from 'react'
import { cx } from '@/lib/utils/utils'

export function FormErrorMessage({
  className,
  ...props
}: {
  message: ReactNode | undefined
  withoutMarginLeft?: boolean
  className?: string
}): ReactElement {
  return (
    <div
      className={cx(
        'box-border h-5 overflow-hidden text-ellipsis whitespace-nowrap text-xs leading-5 text-red-500',
        { 'ml-3': !props.withoutMarginLeft },
        className,
      )}
    >
      {props.message}
    </div>
  )
}
